import { FeedbackReviewIcon } from "components/icons/FeedbackReviewIcon";
import { InProgressIcon } from "components/icons/InProgressIcon";
import { ProcessingIcon } from "components/icons/ProcessingIcon";
import {
  FILING_IN_PROGRESS,
  IN_REVIEW,
  NOT_STARTED,
  PENDING_DETAILS,
  PROCESSING,
  VALIDATING,
} from "constants/salesTaxRegistrationStatusType";
import { RegistrationStatus } from "store/apis/salesTaxRegistration";

const getStatusText = (status: string) => {
  switch (status) {
    case NOT_STARTED:
    case PENDING_DETAILS:
      return {
        title: "Registration not started",
        description:
          "State is added from nexus tracker once nexus is established. Provide details to proceed.",
        Icon: <ProcessingIcon size={20} />,
      };
    case IN_REVIEW:
      return {
        title: "Registration in review",
        description:
          "Our admin team is reviewing your information to ensure everything is accurate before proceeding.",
        Icon: <InProgressIcon size={20} />,
      };
    case PROCESSING:
      return {
        title: "Registration in process",
        description:
          "Tax authority is processing your license. Expect delivery to your mailing address in 1-2 weeks. Add details once you receive.",
        Icon: <FeedbackReviewIcon size={20} />,
      };
    case VALIDATING:
      return {
        title: "In cart",
        description:
          "This registration has been added to your cart. Complete payment to start processing.",
        Icon: <ProcessingIcon size={20} />,
      };
    case FILING_IN_PROGRESS:
      return {
        title: "Filing in progress",
        description:
          "Payment received — our team is actively working on this filing.",
        Icon: <InProgressIcon size={20} />,
      };
    default:
      return {
        title: "",
        description: "",
        Icon: <InProgressIcon size={20} />,
      };
  }
};

export const RegistrationStatusCard = ({
  status = NOT_STARTED,
}: {
  status?: RegistrationStatus;
}) => {
  const { title, description, Icon } = getStatusText(status);
  return (
    <div className="t-flex t-flex-col t-my-4 t-items-center t-p-4 t-py-6 t-justify-center t-border t-border-solid t-border-neutral-10 t-rounded-lg">
      <div className="t-bg-surface-grey t-w-12 t-h-12 t-text-neutral-30 t-rounded-full t-flex t-items-center t-justify-center">
        {Icon}
      </div>

      <span className="t-text-text-60 t-text-subtext t-mt-2">{title}</span>

      <p className="t-text-text-60 t-text-body-sm t-font-light t-m-0 t-text-center">
        {description}
      </p>
    </div>
  );
};
